export const validation = {
  headingMaxChar: 40,
  paragraphMaxChar: 70,
  dateLabelsMaxChar: 15,
  dateLabels: { required: true },
  title: { required: true }
}
